import { object, string } from '@calendly/form/validation'

import { getEffectiveNotificationType } from 'features/event_type_editor'

// CRUD-only notification settings that live on the notifications tab landing view
// (reply-to address, cancellation policy, and the include cancel/reschedule links
// checkbox). These are persisted through the parent CRUD save rather than an
// implicit PATCH, so the values must participate in the shared root form state.
// Field names and server mapping mirror the legacy notification drawer config so
// business logic is unchanged.

const CANCELLATION_POLICY_MAX_LENGTH = 1024

export const getNotificationSettingsInitialValues = (eventType) => ({
  notificationType: getEffectiveNotificationType(eventType, eventType.notification_type),
  noReply: eventType.no_reply_enabled ? 'no-reply' : 'hosts',
  cancellationAllowed: eventType.cancellation_allowed,
  cancellationPolicyEnabled: Boolean(eventType.cancellation_policy),
  cancellationPolicy: eventType.cancellation_policy || ''
})

export const formatNotificationSettingsValues = (values, eventType) => ({
  notification_type: eventType
    ? getEffectiveNotificationType(eventType, values.notificationType)
    : values.notificationType,
  no_reply_enabled: values.noReply === 'no-reply',
  cancellation_allowed: values.cancellationAllowed,
  cancellation_policy: values.cancellationPolicyEnabled ? values.cancellationPolicy : ''
})

export const getNotificationSettingsValidationSchema = () => object({
  cancellationPolicy: string().max(CANCELLATION_POLICY_MAX_LENGTH)
})
